<template src="./Chart.html"></template>

<script>
import { Chart, registerables } from "chart.js";

Chart.register(...registerables);

export default {
  name: "Chart",
  props: {
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: "line",
    },
  },
  data() {
    return {
      chartInstance: null,
    };
  },
  mounted() {
    this.renderChart();
  },
  watch: {
    data: {
      handler() {
        this.updateChart();
      },
      deep: true,
    },
    type() {
      this.renderChart();
    },
  },
  methods: {
    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const ctx = this.$refs.canvas.getContext("2d");

      let options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: "bottom",
          },
          tooltip: {
            mode: "index",
            intersect: false,
          },
        },
        scales: {},
      };

      if (this.type === "bar") {
        options.indexAxis = "y";
        options.scales = {
          x: {
            beginAtZero: true,
            grid: {
              display: true,
            },
          },
          y: {
            grid: {
              display: false,
            },
            ticks: {
              autoSkip: false,
            },
          },
        };
      } else if (
        this.type !== "polarArea" &&
        this.type !== "pie" &&
        this.type !== "doughnut"
      ) {
        options.scales = {
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 2,
            },
          },
          x: {
            grid: {
              display: false,
            },
          },
        };
      } else {
        // Options for graphs of pastel/donuts
        options.scales = {
          x: {
            display: false,
          },
          y: {
            display: false,
          },
        };
      }

      this.chartInstance = new Chart(ctx, {
        type: this.type,
        data: this.data,
        options: options,
      });
    },
    updateChart() {
      if (this.chartInstance) {
        this.chartInstance.data = this.data;
        this.chartInstance.update();
      } else {
        this.renderChart();
      }
    },
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  },
};
</script>

<style scoped>
.chart-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

canvas {
  width: 100% !important;
  height: 100% !important;
  display: block;
}
</style>
